import { connect } from 'react-redux';
import AggregateContainer from '../../../../../components/event/AggregateContainer';
import {
  getDashboardEventAggregationType,
  getDashboardEventSplitColumn,
} from '../../../../../reducers/analyticsApp';
import { setAggregationType } from '../../../../../actions/dashboards/events';

const mapStateToProps = (state, { unitId, id }) => ({
  aggregationType: getDashboardEventAggregationType(state, unitId, id),
  splitColumn: getDashboardEventSplitColumn(state, unitId, id),
});

const mapDispatchToProps = (dispatch, { unitId, id }) => ({
  onChangeAggregationType: (v) => dispatch(setAggregationType(unitId, id, v)),
});

const AggregationContainer = connect(mapStateToProps, mapDispatchToProps)(AggregateContainer);

export default AggregationContainer;
